import { z } from 'zod';
import {
  BullMQPayloadBaseSchema,
  JobRedisStateBaseSchema,
  RequestParamsBaseSchema,
} from './base.js';

/** BullMQ envelope pushed by `POST /api/jobs/submit-generation-only` (Path 2). */
export const GenerationOnlyPayloadSchema = BullMQPayloadBaseSchema.passthrough();
export type GenerationOnlyPayload = z.infer<typeof GenerationOnlyPayloadSchema>;

/**
 * Path-2 request_params. `.max()` caps are defensive bounds to prevent
 * unbounded Redis payloads and LLM-cost amplification. `templateType` is
 * locally optional (override of the base) because Path 2 can be triggered
 * directly without the Path-1 parent metadata.
 */
export const GenerationOnlyRequestParamsSchema = RequestParamsBaseSchema.extend({
  actId: z.string().regex(/^act_[0-9a-f]{32}$/).optional(),
  // templateType may be undefined when generation-only is triggered directly.
  templateType: z.string().optional(),
  original_job_id: z.string().uuid(),
  // ~500KB cap (~125k tokens) — well below Claude Sonnet 4.5's 200k context
  // window, leaving headroom for system prompt + template + output.
  legal_arguments_with_jurisprudence: z.string().max(500_000),
  additional_instructions: z.string().max(100_000).optional(),
  generation_mode: z.enum(['full', 'section_i', 'section_ii_iii']).optional(),
  // ~200KB cap — Section I content only, typically < 20KB in practice.
  // `.nullable()` because the route persists `null` when absent.
  previous_section_content: z.string().max(200_000).nullable().optional(),
}).passthrough();
export type GenerationOnlyRequestParams = z.infer<typeof GenerationOnlyRequestParamsSchema>;

export const GenerationOnlyJobDataSchema = JobRedisStateBaseSchema
  .extend({
    request_params: GenerationOnlyRequestParamsSchema,
  })
  .passthrough();
export type GenerationOnlyJobData = z.infer<typeof GenerationOnlyJobDataSchema>;
